// Modules
import React from "react";

const BathroomEquipmentIcon = (props) => {
	return (
		<svg
			height="1em"
			viewBox="0 0 480 480"
			width="1em"
			x="0px"
			y="0px"
			xmlns="http://www.w3.org/2000/svg"
			style={{ enableBackground: "new 0 0 480 480" }}
			{...props}
		>
			<g>
				<path d="M400,176h-60.992c18.66-19.316,29.06-45.143,28.992-72c0-4.418-3.582-8-8-8h-56V80c0-4.418-3.582-8-8-8h-32
				c-4.418,0-8,3.582-8,8v16h-8V40c0-13.255,10.745-24,24-24s24,10.745,24,24c0,4.418,3.582,8,8,8s8-3.582,8-8
				c0-22.091-17.909-40-40-40c-22.091,0-40,17.909-40,40v56h-8V80c0-4.418-3.582-8-8-8h-32c-4.418,0-8,3.582-8,8v16h-56
				c-4.418,0-8,3.582-8,8c-0.01,26.867,10.427,52.686,29.104,72H80c-4.418,0-8,3.582-8,8v208c0,4.418,3.582,8,8,8h8v72
				c0,4.418,3.582,8,8,8h24c3.911-0.002,7.247-2.83,7.888-6.688l5.776-34.632c0.645-3.854,3.98-6.679,7.888-6.68h196.896
				c3.908,0.001,7.243,2.826,7.888,6.68l5.776,34.632c0.641,3.858,3.977,6.686,7.888,6.688h24c4.418,0,8-3.582,8-8v-72h8
				c4.418,0,8-3.582,8-8V184C408,179.582,404.418,176,400,176z M272,88h16v8h-16V88z M192,88h16v8h-16V88z M128.36,112h223.288
				c-2.297,25.74-15.829,49.157-36.984,64h-149.24C144.217,161.193,130.648,137.763,128.36,112z M88,384V192h144v192H88z M376,464
				h-9.224l-4.656-27.944c-1.9-11.588-11.929-20.085-23.672-20.056H141.552c-11.743-0.029-21.772,8.468-23.672,20.056L113.224,464
				H104v-64h272V464z M392,384H248V192h144V384z"/>
				<path d="M264,312c4.418,0,8-3.582,8-8v-32c0-4.418-3.582-8-8-8s-8,3.582-8,8v32C256,308.418,259.582,312,264,312z" />
				<path d="M216,264c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8s8-3.582,8-8v-32C224,267.582,220.418,264,216,264z" />
			</g>
		</svg>
	);
};

export default BathroomEquipmentIcon;
